import TermsConditions from './TermsConditions.jsx';

export default TermsConditions